const VERSION: string = '0.1.7-prod.111'
export default VERSION;
